














































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { DocumentExportOptionsModel } from '@/types/models/document/DocumentExportOptionsModel';
import { DocumentViewerConstants } from '@/types/constants/DocumentViewerConstants';
import { ErrorCode } from '@/types/enums/ErrorCode';
import { DocumentViewerToolbarOptionsModel } from '@/types/models/documentView/DocumentViewerToolbarOptionsModel';
import { DocumentService } from '@/services/DocumentService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import DocumentViewerToolbar from '@/components/shared/DocumentViewerToolbar.vue';
import MStoreThumbnailViewList from '@/components/shared/MStoreThumbnailViewList.vue';
import DocumentViewerPlaceholder from '@/components/shared/DocumentViewerPlaceholder.vue';
import DocumentExportModal from '@/components/shared/DocumentExportModal.vue';
import moment from 'moment';
import { dragscroll } from 'vue-dragscroll';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { DeviceHelper } from '@/mixins/deviceHelper';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';
import ResizeObserver from 'resize-observer-polyfill';
import { ErrorUtils } from '@/utils';
import { BaseDocumentSearchModel, DocumentActionsModel, EditReferences, EditReferencesButtonTooltipModel, Workflow, DocumentModel, DocumentPagePreferencesModel, EVENT_BUS } from '@/types';
import { EventBus } from '@/classes/EventBus';
import ApiConfiguration from '@/classes/ApiConfiguration';

export default Vue.extend({
  name: 'DocumentViewer',
  mixins: [DeviceHelper, AppSettingsHelper],
  props: {
    hideToolbar: {
      type: Boolean,
      default: false
    },
    loadFirstPage: {
      type: Boolean,
      default: true
    },
    imageFooterVariant: {
      type: String,
      default: 'secondary'
    },
    showImageFooter: {
      type: Boolean,
      default: true
    },
    toolOptions: {
      type: Object as () => DocumentViewerToolbarOptionsModel
    },
    hideThumbnails: {
      type: Boolean,
      default: false
    },
    loadPageOnThumbnailClick: {
      type: Boolean,
      default: true
    },
    reloadCurrentPageOnDelete: {
      type: Boolean,
      default: true
    },
    exportOptions: {
      type: Object as () => DocumentExportOptionsModel
    },
    showDocumentPlaceholder: {
      type: Boolean,
      default: false
    },
    documentPlaceholderText: {
      type: String,
      default: ''
    },
    editReferencesTooltip: {
      type: Object as () => EditReferencesButtonTooltipModel
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageLoaded: '',
      imageClicked: false,
      imageProperties: {
        width: 0,
        height: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        rotationDegrees: 0,
        originalWidth: 0,
        originalHeight: 0,
        containerWidth: 0,
        containerHeight: 0,
        containerPadding: 10
      },

      imageFooterProperties: {
        viewerContainerHeight: 0,
        imageFooterHeight: 0,
        imageFooterWidth: 0,
        imageContainerOffsetHeight: 0,
        imageContainerHeight: 0,
        imageContainerWidth: 0
      },

      exportPending: false,
      originalDocumentRotation: 0,
      nowIntervalId: 0,
      now: moment(),
      isFirstLoad: true,
      showDocumentExportModal: false,
      showPdfModal: false,
      pdfSrc: null,
      pdfLoading: false
    };
  },
  methods: {
    ...mapActions('documentViewStore', ['loadPage', 'setDocumentSearchModel', 'setIsConversionSlow', 'deleteDocument', 'deletePage', 'retrieveDocumentActions']),
    ...mapActions('thumbnailStore', ['clearThumbnailCacheForDocument']),
    setImageProperties(this: any, setImageLoaded: boolean) {
      const image = this.$refs.image as HTMLImageElement;
      const imageContainer = this.$refs.imageContainer as HTMLDivElement;
      this.imageProperties.originalWidth = image.naturalWidth;
      this.imageProperties.originalHeight = image.naturalHeight;
      this.imageProperties.containerWidth = imageContainer.clientWidth;
      this.imageProperties.containerHeight = imageContainer.clientHeight;
      if (setImageLoaded && this.isFirstLoad) {
        this.isFirstLoad = false;
        this.imageLoaded = moment()
          .format()
          .toString();
      }
      this.$nextTick(() => {
        this.setImageFooterProperties();
      });
    },
    getRotationValue(this: any, rotation: string) {
      switch (rotation) {
        case 'Rotate90': {
          return 90;
        }
        case 'Rotate180': {
          return 180;
        }
        case 'Rotate270': {
          return 270;
        }
        default: {
          return 0;
        }
      }
    },
    setImageFooterProperties(this: any) {
      const imageContainer = this.$refs.imageContainer as HTMLDivElement;
      this.imageFooterProperties.imageContainerOffsetHeight = imageContainer.offsetHeight;
      this.imageFooterProperties.imageContainerHeight = imageContainer.clientHeight;
      this.imageFooterProperties.imageContainerWidth = imageContainer.clientWidth;
      const imageFooter = this.$refs.imageFooter as HTMLDivElement;
      this.imageFooterProperties.imageFooterHeight = imageFooter.clientHeight;
      this.imageFooterProperties.imageFooterWidth = imageFooter.clientWidth;
      const viewerContainer = this.$refs.viewerContainer as HTMLDivElement;
      this.imageFooterProperties.viewerContainerHeight = viewerContainer.clientHeight;
    },
    openExportDocumentModel(this: any) {
      this.showDocumentExportModal = true;
    },
    closeExportDocumentModal(this: any) {
      this.showDocumentExportModal = false;
    },
    async onExportDocument(this: any, documentActionsModel: DocumentActionsModel, fileName: string) {
      this.exportPending = true;
      try {
        if (documentActionsModel.exportRelatedDocuments) {
          await this.exportMultipleDocumentsAsZip(fileName, this.documentSearchModel.cabinetId, this.documentSearchModel.documentId);
        } else {
          await this.exportDocument(fileName, this.document?.cabinetId, this.document?.id ? this.document.id : this.documentSearchModel.documentId);
        }
      } finally {
        this.showDocumentExportModal = false;
        this.exportPending = false;
      }
    },

    async exportDocument(this: any, fileName: string, cabinetId: string, documentId: number) {
      await DocumentService.exportDocumentAsync(cabinetId, documentId, this.exportDocumentOptions)
        .then((response) => {
          const contentDisposition = response.headers['content-disposition'];
          const blobObject = new Blob([response.data]);
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileName.concat('.', fileNameMatch[1].split('.').pop());
            }
          }
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(async (error: any) => {
          try {
            const errorModel = await ErrorUtils.getExceptionResponseModelFromBlob(error.response.data);
            SnotifyConfiguration.showNotification(errorModel.notification, errorModel.presentationType);
          } catch (error) {
            this.$log(error);
          }
        });
    },
    async exportMultipleDocumentsAsZip(this: any, fileName: string, cabinetId: string, documentId: number) {
      await DocumentService.exportMultipleDocumentAsZipAsync(cabinetId, documentId, this.exportDocumentOptions, fileName)
        .then((response) => {
          const blobObject = new Blob([response.data]);
          fileName = fileName.concat('.', 'zip');
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(async (error: any) => {
          try {
            const errorModel = await ErrorUtils.getExceptionResponseModelFromBlob(error.response.data);
            SnotifyConfiguration.showNotification(errorModel.notification, errorModel.presentationType);
          } catch (error) {
            this.$log(error);
          }
        });
    },
    onDeleteDocument(this: any) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this document?', {
          title: 'Are you sure?',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelVariant: 'primary',
          cancelTitle: 'No'
        })
        .then(async (result: boolean) => {
          if (result) {
            const originalDocumentSearchModel: BaseDocumentSearchModel = {
              cabinetId: this.documentSearchModel.cabinetId,
              documentId: this.documentSearchModel.documentId,
              documentTypeId: this.documentSearchModel.documentTypeId
            };
            await this.deleteDocument();
            this.$emit('deleteDocument');
            if (this.$route.name === Workflow.Job.name) {
              await this.reloadDocumentViewer(originalDocumentSearchModel);
            }
          }
        });
    },
    async reloadDocumentViewer(this: any, originalDocumentSearchModel: BaseDocumentSearchModel) {
      this.setDocumentSearchModel(originalDocumentSearchModel);
      await this.loadPage(1);
      this.$emit('onDeleteDocument', originalDocumentSearchModel);
    },
    onDeleteDocumentPage(this: any) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this page?', {
          title: 'Are you sure?',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelVariant: 'primary',
          cancelTitle: 'No'
        })
        .then((result: boolean) => {
          if (result) {
            this.deletePage({ pageNumber: this.currentPage, reloadPageOnDelete: this.reloadCurrentPageOnDelete });
          }
        });
    },
    onEditDocument(this: any) {
      this.$router.push({
        name: EditReferences.EditReferences.name,
        params: {
          sourceCabinetId: this.document.cabinetId,
          sourceDocumentTypeId: this.document.documentTypeId,
          sourceDocumentId: this.document.id
        }
      });
    },
    setNowToNow(this: any) {
      this.now = moment();
    },
    onViewerContainerResize(this: any, tab: HTMLElement) {
      this.$nextTick(() => {
        this.setImageProperties(false);
      });
    },
    onImageContainerResize(this: any, tab: HTMLElement) {
      this.$nextTick(() => {
        this.setImageFooterProperties(false);
      });
    },
    onThumbnailPageClick(this: any, page: number) {
      this.loadPage(page);
      this.setPageRotation(page);
    },
    async showAsPdf(this: any) {
      this.showPdfModal = true;
      this.pdfLoading = true;
      try {
        const document = this.document as DocumentModel;
        const pdfBase64 = await DocumentService.getDocumentAsPdfAsync(document.cabinetId, document.id);
        this.pdfSrc = `data:application/pdf;base64,${pdfBase64}`;
      } finally {
        this.pdfLoading = false;
      }
    },
    pdfModalHidden(this: any) {
      this.pdfSrc = null;
    },
    async onRotationChanged(this: any, rotationDegree: number) {
      if (this.document.autoSaveConfiguration?.enabled) {
        EventBus.$emit('thumbnailRotationChange', { page: this.currentPage, rotation: rotationDegree !== 0 ? `Rotate${rotationDegree}` : 'None' } as DocumentPagePreferencesModel);
        const documentPagePreference = {
          page: this.currentPage,
          rotation: `Rotate${rotationDegree}`
        } as DocumentPagePreferencesModel;
        const pagePreferenceToUpdate = this.document.documentPagePreferences.find((x: any) => x.page === this.currentPage);
        if (pagePreferenceToUpdate) {
          pagePreferenceToUpdate.rotation = documentPagePreference.rotation;
        } else {
          this.document.documentPagePreferences.push(documentPagePreference);
        }
        await DocumentService.updateDocumentPagePreferenceSettings(this.document.id, documentPagePreference);
      }
    },
    setPageRotation(this: any, pageNumber: number) {
      const pagePreferences = this.document.documentPagePreferences.find((x: any) => x.page === pageNumber);
      this.imageProperties.rotationDegrees = pagePreferences ? this.getRotationValue(pagePreferences.rotation) : 0;
    },
    async createDocumentHistoryViewLog(this: any) {
      await ApiConfiguration.apiWithErrorPage().document.documentViewHistoryLogCreate(this.document.id);
      EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
    }
  },
  computed: {
    ...mapGetters('documentViewStore', [
      'document',
      'hasDocumentError',
      'isPageLoading',
      'hasDocumentLoaded',
      'documentSearchModel',
      'documentPage',
      'showLoadingSpinner',
      'currentPage',
      'isDeleting',
      'documentActions'
    ]),
    imageStyles(this: any): string {
      return `width: ${this.imageProperties.width}px;
            height: ${this.imageProperties.height}px;
            transform: rotate(${this.imageProperties.rotationDegrees}deg);
            padding: ${this.imageProperties.containerPadding}px;
            marginTop: ${this.imageProperties.marginTop}px;
            marginBottom: ${this.imageProperties.marginBottom}px;
            marginLeft: ${this.imageProperties.marginLeft}px;
            marginRight: ${this.imageProperties.marginRight}px;`;
    },
    isUnsupportedFileType(this: any): boolean {
      return this.document.errorCode === ErrorCode.UnsupportedFileType;
    },
    conversionHasTakenLongerThanConfiguredPeriod(this: any) {
      if (this.hasDocumentLoaded) {
        const requestedDate = moment(this.document.conversionRequestedDate);
        return requestedDate.diff(this.now, 's') < -this.appSettings.presentExportOptionWhenConvertingDocumentAfterSeconds;
      }
    },
    imageFooterStyles(this: any): string {
      const imageFooterBottomMargin = 2;
      const left = Math.floor((this.imageFooterProperties.imageContainerWidth - this.imageFooterProperties.imageFooterWidth) / 2);
      const maxWidth = Math.floor(this.imageFooterProperties.imageContainerWidth / 2);
      const imageHorizontalScrollbarHeight = this.imageFooterProperties.imageContainerOffsetHeight - this.imageFooterProperties.imageContainerHeight;
      const top = this.imageFooterProperties.viewerContainerHeight - (this.imageFooterProperties.imageFooterHeight + imageHorizontalScrollbarHeight + imageFooterBottomMargin);
      return `left: ${left}px; top: ${top}px; max-width: ${maxWidth}px`;
    },
    hasImageFooterSlot() {
      return !!this.$slots.imageFooter;
    },
    isPageLoaded(): boolean {
      return !this.isPageLoading && !this.document.hasNotification && !this.document.isBeingConverted;
    },
    toolbarOptions(): DocumentViewerToolbarOptionsModel {
      return this.toolOptions ? this.toolOptions : DocumentViewerConstants.DocumentViewerDeleteEnabledToolOptions;
    },
    editReferencesButtonTooltip(): EditReferencesButtonTooltipModel {
      const defaultEditReferencesTooltip: EditReferencesButtonTooltipModel = {
        disabledTooltipMessage: '',
        important: false
      };
      return this.editReferencesTooltip ? this.editReferencesTooltip : defaultEditReferencesTooltip;
    },
    isPageConverted(): boolean {
      return !this.document.hasNotification && this.document.viewConversionId;
    },
    showSpinner(): boolean {
      return this.isDeleting || (this.isPageLoading && !this.document.isBeingConverted && this.showLoadingSpinner && !this.document.hasNotification);
    },
    exportDocumentOptions(): DocumentExportOptionsModel {
      return this.exportOptions ? this.exportOptions : DocumentViewerConstants.DefaultLockExportOptions;
    },
    showThumbnails(this: any) {
      return !this.hideThumbnails && this.document.totalPages > 1 && !this.isPageConverted && !this.showDocumentPlaceholder;
    }
  },
  watch: {
    isPageLoading(this: any) {
      if (this.isPageLoading) {
        if (this.document.id === this.documentSearchModel?.documentId) {
          const pagePreferences = this.document.documentPagePreferences?.find((x: DocumentPagePreferencesModel) => x.page === this.currentPage);
          this.imageProperties.rotationDegrees = pagePreferences ? this.getRotationValue(pagePreferences.rotation) : 0;
          this.originalDocumentRotation = this.imageProperties.rotationDegrees;
        }
        if (!this.document.id) {
          this.originalDocumentRotation = 0;
        }
      } else {
        if (this.document.id === this.documentSearchModel?.documentId || this.document?.documentPagePreferences) {
          const pagePreferences = this.document.documentPagePreferences?.find((x: any) => x.page === this.currentPage);
          this.imageProperties.rotationDegrees = pagePreferences ? this.getRotationValue(pagePreferences.rotation) : 0;
        } else {
          this.imageProperties.rotationDegrees = 0;
        }
      }
    },
    conversionHasTakenLongerThanConfiguredPeriod(this: any, newValue: boolean) {
      if (newValue) {
        this.setIsConversionSlow(true);
      }
    },
    showImageFooter(this: any, value) {
      if (value) {
        this.$nextTick(() => {
          this.setImageFooterProperties(false);
        });
      }
    },
    documentSearchModel: {
      immediate: true,
      handler(this: any, newValue, oldValue) {
        if (newValue && newValue.documentTypeId && newValue.cabinetId && (newValue.documentTypeId !== oldValue?.documentTypeId || newValue.cabinetId !== oldValue?.cabinetId)) {
          this.retrieveDocumentActions();
        }
      }
    },
    document(this: any, value) {
      if (value.id) {
        this.clearThumbnailCacheForDocument(value.id);
        this.createDocumentHistoryViewLog();
      }
    }
  },
  async mounted(this: any) {
    if (this.loadFirstPage) {
      this.loadPage(1);
    }

    this.nowIntervalId = setInterval(this.setNowToNow, 1000);

    const viewerContainer = document.getElementById('viewerContainer') as HTMLElement;
    this.viewerResizeObserver = new ResizeObserver(() => this.onViewerContainerResize(viewerContainer));
    this.viewerResizeObserver.observe(viewerContainer);

    const imageContainer = document.getElementById('imageContainer') as HTMLElement;
    this.imageResizeObserver = new ResizeObserver(() => this.onImageContainerResize(imageContainer));
    this.imageResizeObserver.observe(imageContainer);

    if (this.document.id === this.documentSearchModel?.documentId) {
      const pagePreferences = this.document.documentPagePreferences?.find((x: DocumentPagePreferencesModel) => x.page === this.currentPage);
      this.imageProperties.rotationDegrees = pagePreferences ? this.getRotationValue(pagePreferences.rotation) : 0;
    }
  },
  beforeDestroy(this: any) {
    clearInterval(this.nowIntervalId);
    this.viewerResizeObserver.disconnect();
    this.imageResizeObserver.disconnect();
  },
  components: {
    LoadingSpinner,
    DocumentViewerToolbar,
    MStoreThumbnailViewList,
    DocumentViewerPlaceholder,
    DocumentExportModal
  },
  directives: {
    dragscroll
  }
});
